// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "assets/css/" + {"4255":"test","8140":"prod"}[chunkId] + ".chunk.css?v=" + __webpack_require__.h() + "";
};